import React from 'react'

import VisualizationWelcomeBanner from 'components/VisualizationWelcomeBanner'
import useAuth from 'hooks/use-auth'
import useClientResource from 'hooks/use-client-resource'
import { useGetCompanyWithoutTeams } from 'hooks/use-get-company-without-teams'
import { useGetTeams } from 'hooks/use-get-teams-paged'
import theme from 'theme'
import { getMappedCompanyData } from 'utils/company'
import { companiesIdPatch } from 'utils/endpoints-access'

import InstallBanner from '../notification-banners/InstallBanner'
import ProfileSection from './ProfileSection'
import { TeamSection } from './TeamSection'

const TopBanner: React.FC<{
  hasMetricsDisabled: boolean
}> = ({ hasMetricsDisabled, ...rest }) => {
  const { hasEndpointAccess } = useAuth()
  const { hasClients, infraIsLoading, alfiIsLoading } = useClientResource()

  const canEditCompanyPrefs = hasEndpointAccess(companiesIdPatch)

  if (infraIsLoading || alfiIsLoading) return null

  return (
    <div
      css={{
        marginBottom: theme.space[1]
      }}
      {...rest}
    >
      {!hasClients && <InstallBanner showSubheader />}

      {hasClients && hasMetricsDisabled && canEditCompanyPrefs && (
        <VisualizationWelcomeBanner css={{ marginTop: theme.space[3] }} />
      )}
    </div>
  )
}

export const DashboardHeader: React.FC = () => {
  const {
    data: companyData,
    isFetching: isFetchingCompany,
    refetch: refetchCompany
  } = useGetCompanyWithoutTeams()

  const company = getMappedCompanyData(companyData)

  const {
    data: teams = [],
    isFetching: isFetchingTeams,
    refetch: refetchTeams
  } = useGetTeams()

  const isLoading = isFetchingCompany || isFetchingTeams

  return (
    <>
      <div
        data-test-dashboard-header
        css={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          marginBottom: 0
        }}
      >
        <ProfileSection />
        <TeamSection
          company={company}
          doFetch={async () => {
            refetchCompany()
            refetchTeams()
          }}
          isLoading={isLoading}
          teams={teams}
        />
      </div>

      <TopBanner
        hasMetricsDisabled={
          !isFetchingCompany && !company?.prefs?.monitoring?.opt_in?.value
        }
      />
    </>
  )
}
